// extracted by mini-css-extract-plugin
module.exports = {"bordered":"OrderCard_bordered__2cwAo","footer-number":"OrderCard_footer-number__2CK7f"};